<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgements" id="acknowledgements">
<p class="chapterTitle"><span class="t12"><span class="bold">Acknowledgements</span></span></p>
<p class="paraNoIndent">Thanks are due to Laura Carter who did the line drawings, to my friends and contacts in Liverpool who have helped with anecdotes, and to arguably the most dedicated true crime writer from Merseyside, Richard Whittington-Egan.</p>
<p class="para">Acknowledgements for permission to use pictorial material are due to Liverpool Record Office and to Liverpool Central Library. For much of the sociological data, the survey done by the University of Liverpool in 1934 has been invaluable.</p>
<p class="para">I have to thank Clifford Elmer Books for permission to use the Wallace case cover and the Maybrick illustration. Andy Tennick did several drawings also and talk about some of the cases with local writers was very valuable.</p>
<p class="para">Finally, thanks are due to Liverpool Record Office for permission to reproduce images of Mr Aspinall, Silvester Court and Kirkdale Gaol, used in the Flanagan and Higgins murder case.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_acknowledgements.vue?797c7832